/*eslint-disable */
import 'vue-datetime/dist/vue-datetime.css'
import Multiselect from 'vue-multiselect'
import { VueEditor } from "vue2-editor";
import toast from '@/services/toast';
import blogDisclaimer from '../blog-disclaimer';
import { bus } from '@/main';
import {
mapGetters,
} from 'vuex';
export default {
  name: 'create-blog',
  components: {
    VueEditor,
    blogDisclaimer,
    Multiselect
  },
  props: [],
  data() {
    return {
      categoryData: ['Acute Lymphoblastic Leukemia ',
        'Acute Myeloid Leukaemia',
        'Adenocarcinoma',
        'Allogenic Stem Cell Transplant',
        'Anatomy',
        'Artificial Intelligence in Medicine',
        'Autoimmune Diseases',
        'Autologous Stem Cell Transplant',
        'Biochemistry',
        'Biomedical Engineering',
        'Biotechnology',
        'Bone Cancer',
        'Breast Cancer',
        'CNS Tumor',
        'COVID/Sar-Cov',
        'Cancer Biology',
        'Cancer Care',
        'Cancer Research',
        'Cancer Treatment',
        'Carcinoid Tumors',
        'Cardiology',
        'Cell Biology',
        'Cervical Cancer',
        'Chemotherapy',
        'Chronic Myeloid Leukaemia',
        'Clinical Trials',
        'Colorectal Cancer',
        'Computational Pathology',
        'Computational Radiology',
        'Data Science',
        'Dermatology',
        'Diffuse Large B Cell Lymphoma',
        'Diseases',
        'Drug Discovery',
        'Drugs',
        'ENT',
        'Esophageal Cancer',
        'Gastric Cancer',
        'Gastroenterology',
        'Gastrointestinal Stromal Tumor',
        'Glioblastoma',
        'Gynaecology',
        'HIV',
        'HPV',
        'Head and Neck Cancer',
        'Hematology',
        'Hepatitis',
        'Hepatocellular Carcinoma',
        'Hodgkin’s Lymphoma',
        'Hospital Management',
        'Immunology',
        'Immunotherapy',
        'Liver Cancer',
        'Lung Cancer',
        'Mathematical Oncology',
        'Medical Big Data',
        'Medical Machine Learning',
        'Medical Oncology',
        'Medical Physics',
        'Medulloblastoma',
        'Melanoma',
        'Multiple Myeloma',
        'Neurology',
        'Neuroscience',
        'Non-Hodgkin’s Lymphoma',
        'Nuclear Medicine',
        'Oncology',
        'Orthopaedics',
        'Other Healthcare Issue',
        'Ovarian Cancer',
        'Paediatric Oncology',
        'Paediatrics',
        'Palliative Cancer Therapy',
        'Pancreatic Cancer',
        'Pancreatic Neuroendocrine Tumor',
        'Pathology',
        'Pharmaceutical Sciences',
        'Pharmacology',
        'Physiology',
        'Primitive Neuroectodermal Tumor',
        'Prostrate Cancer',
        'Psychiatry',
        'Psychology',
        'Pulmonary Medicine',
        'Radiation Oncology',
        'Radiology',
        'Radiotherapy',
        'Renal Cell Carcinoma',
        'Retinoblastoma',
        'Sarcoma',
        'Signet Ring Cell Carcinoma',
        'Small Cell Carcinoma',
        'Stem Cell Science',
        'Surgery',
        'Surgical Oncology',
        'Testicular Cancer',
        'Therapeutics',
        'Throat Cancer',
        'Toxicology',
        'Urology',
        'Uterine Cancer',
        'Vaccine',
        'Virology'
      ],
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
      is_publish: false,
      submitted: false,
      title: '',
      category: '',
      content: '',
      file: null,
      uploadAttachmentName: '',
      selfUserId: '',
      uploadImgSize: false,
      blogDisclaimer:false,
      options:[],
      userList:null,
      userListResults:[],
      authorUser:[]
    }
  },
  computed: {
    ...mapGetters([
      'isConditionalListOfAllUsersGetters'
    ]),
    getUserList() {
      this.userList = this.$store.getters.isConditionalListOfAllUsersGetters.data
      return this.userList
    },
    setIntialsState(){
      if(this.userList != null){
        this.userListResults = this.userList
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    }
  },
  mounted() {
    this.blogDisclaimer = true
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    bus.$on('blogDisclaimerBus', (data) => {
      this.blogDisclaimer = data
    })
    this.getUserList
    this.setIntialsState
  },
  methods: {
    selectedCategoryFun(val) {
      this.category = val
    },
    blogPublishedToggle() {
      if (this.is_publish === false) {
        this.is_publish = true
      } else {
        this.is_publish = false
      }
    },
    // GET THE IMAGE WIDTH AND HEIGHT USING fileReader() API.
    readImageFile(file) {
      var __self = this
      var reader = new FileReader(); // CREATE AN NEW INSTANCE.
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          var w = this.width;
          var h = this.height;
          if (w > 1200 && h > 150) {
            __self.uploadImgSize = true
          } else {
            __self.uploadImgSize = false
          }
        }
      };
      reader.readAsDataURL(file);
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.readImageFile(event.target.files[0])
        setTimeout(() => {
          if (this.uploadImgSize) {
            this.file = event.target.files[0];
            this.files = this.$refs.file.files[0];
            this.uploadAttachmentName = this.files.name
          } else {
            alert("The Height And Width Must Be Greater Than 1200px * 150px")
          }
        },100)
      }else{
        this.uploadAttachmentName = '';
      }
    },
    cancelUploadingFileFun() {
      this.file = null
      this.files = null
      this.uploadAttachmentName = '';
      this.uploadImgSize = false
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.authorUser.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    createBlogBeforeSubmitMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          var formData = new FormData();
          formData.append('user', this.authorUser.id || this.selfUserId);
          formData.append('title', this.title);
          formData.append('data', this.content);
          formData.append('category', this.category);
          formData.append('is_public', this.is_publish);
          if (this.file != null) {
            formData.append('file', this.file);
          }
          this.$store.dispatch('createBlogDetailsAction', formData).then((res) => {
            this.title = ''
            this.content = ''
            this.file = null
            this.is_publish = false
            this.uploadAttachmentName = ''
            this.$router.push({ name: 'DashboardMain' })
            this.$validator.reset();
            this.submitted = false
            toast.success(res.data.msg);
          }).catch((err) => {
            this.submitted = false
            toast.error(err.data.msg);
          })

        }
      })
    }
  },
  watch:{
    getUserList() {
      return this.$store.getters.isConditionalListOfAllUsersGetters.data
    },
    userList(old_val, new_val){
      if(new_val == undefined){
          this.userListResults = old_val
          for(var i = 0; i < this.userListResults.length; i++){
            this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
          }
      }
    },

  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}